export const PAD_TYPE = {
  INITIAL: 1,
  ALTERATION: 2,
  RENOVATION: 3,
  DISCHARGE: 7,
  PERFECT_WAVE_PHASE_I_INITIAL: 4,
  PERFECT_WAVE_PHASE_I_ALTERATION: 5,
  PERFECT_WAVE_PHASE_I_RENOVATION: 6
};

export const STATUS = {
  REFUSED: 11,
  APPROVED: 12,
  REOPENED: 13,
  EVALUATION: 14,
  LOSS: 15,
  RUNNING: 16,
  AWAITING_BUSINESS_PARTNER: 17,
  IN_PARTIAL_EXECUTION: 18,
  EXECUTED: 19, // status indicating that the patient was discharged
  EXPIRED: 110, // status not indicated in pad_status table because it is a temporal status.
  CONCLUDED: 210 // status not indicated in pad_status table because it is a temporal status.
};

export const PAD_STATUS = {
  APPROVED: 'Aprovado',
  WAITING_FOR_APPROVAL: 'Aguardando aprovação',
  RUNNING: 'Em execução',
  REALIZED: 'Realizado',
  NOT_APPROVED: 'Não aprovado',
  WAITING_FOR_BUSINESS_PARTNER: 'Aguardando Parceiro de Negócio',
  IN_PARTIAL_EXECUTION: 'Em execução parcial'
};

// REFACTOR aplicar essas constantes: src/app/config/pad_item.js
export const PAD_ITEMS = {
  MAT_MED: 1,
  EQUIPMENT: 2,
  FURNITURE: 3
};

export const PAD_CARD_TYPES = {
  VISIT: 'VISIT',
  DIAGNOSTIC: 'DIAGNOSTIC',
  ITEM: 'ITEM',
  PRESCRIPTION: 'PRESCRIPTION'
};

export const PAD_ALTERATION_TYPE = {
  CREATION: 1,
  ALTERATION: 2,
  SUSPENSION: 3
};
